import type { ReactNode } from 'react'
import { ReactLenis } from 'lenis/react'
import { useReducedMotion } from 'framer-motion'

interface SmoothScrollProviderProps {
  children: ReactNode
}

/**
 * Wraps the app in a global Lenis smooth-scroll instance. Skipped entirely
 * when the user prefers reduced motion, falling back to native scrolling.
 */
function SmoothScrollProvider({ children }: SmoothScrollProviderProps) {
  const shouldReduceMotion = useReducedMotion()

  if (shouldReduceMotion) {
    return children
  }

  return (
    <ReactLenis root options={{ duration: 1.1, smoothWheel: true }}>
      {children}
    </ReactLenis>
  )
}

export { SmoothScrollProvider }
